var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M288,32c123.712,0,224,100.288,224,224S411.712,480,288,480v-48c47.012,0,91.209-18.307,124.451-51.549S464,303.012,464,256 c0-47.011-18.307-91.209-51.549-124.451C379.209,98.307,335.012,80,288,80c-47.011,0-91.209,18.307-124.451,51.549 c-25.57,25.569-42.291,57.623-48.653,92.451H208L96,352L-16,224h82.285C81.815,115.449,175.154,32,288,32z M384,224v64H256V128h64 v96H384z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.743ac80874d8c61432f3634e756d7972.svg";
export { ForwardRef as ReactComponent };